<template>
    <div v-if="source">
        <a v-if="isLink(source)" :href="source" target="_blank" class="d-flex" :class="{'justify-content-end': right}"  @click.stop>
            <span v-if="includeSource">{{ $t("source") }}:&nbsp;</span>{{ $t("registr") }} <b-icon icon="box-arrow-up-right" font-scale="0.7" class="ms-1" style="margin-bottom: 5px;"></b-icon>
        </a>
        <span class="light_italic" v-if="!isLink(source)">
            <span v-if="includeSource">{{ $t("source") }}:&nbsp;</span>{{ source }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        source: { default: null, type: String },
        includeSource: { default: true, type: Boolean },
        right: { default: false, type: Boolean }
    },
    methods: {
        isLink: function(value) {
            return value.toLowerCase().startsWith("http");
        }
    }
}
</script>

<style lang="scss">
</style>